import { useIntl } from "react-intl";
import { round } from "../../utils/UnitsUtils";
import styled from "@mui/material/styles/styled";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const ParagraphLine = styled("span")(({ theme }) => ({
    verticalAlign: "baseline",
    height: 1,
    flexGrow: 1,
    flexShrink: 1,
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
    marginLeft: "0.5em",
    marginRight: "0.5em"
}));

export interface NutritionSummaryProps {
    nutritionValues: {
        water: number;
        calories: number;
        carbs: number;
        protein: number;
        fat: number;
        sodium: number;
        caffeine: number;
    };
}

const NutritionSummary: React.FC<NutritionSummaryProps> = ({ nutritionValues }) => {

    const intl = useIntl();

    return (
        <Box>
            <Box display="flex" alignItems="baseline" justifyContent="space-between" marginY={1}>
                <Typography variant="body2">{intl.formatMessage({ id: "data.waterTitle" })}</Typography>
                <ParagraphLine />
                <Typography variant="body2">{round(nutritionValues.water, 2)} L</Typography>
            </Box>
            <Box display="flex" alignItems="baseline" justifyContent="space-between" marginY={1}>
                <Typography variant="body2">{intl.formatMessage({ id: "data.caloriesTitle" })}</Typography>
                <ParagraphLine />
                <Typography variant="body2">{round(nutritionValues.calories, 2)} kcal</Typography>
            </Box>
            <Box display="flex" alignItems="baseline" justifyContent="space-between" marginY={1}>
                <Typography variant="body2">{intl.formatMessage({ id: "data.carbsTitle" })}</Typography>
                <ParagraphLine />
                <Typography variant="body2">{round(nutritionValues.carbs, 2)} g</Typography>
            </Box>
            <Box display="flex" alignItems="baseline" justifyContent="space-between" marginY={1}>
                <Typography variant="body2">{intl.formatMessage({ id: "data.proteinTitle" })}</Typography>
                <ParagraphLine />
                <Typography variant="body2">{round(nutritionValues.protein, 2)} g</Typography>
            </Box>
            <Box display="flex" alignItems="baseline" justifyContent="space-between" marginY={1}>
                <Typography variant="body2">{intl.formatMessage({ id: "data.fatTitle" })}</Typography>
                <ParagraphLine />
                <Typography variant="body2">{round(nutritionValues.fat, 2)} g</Typography>
            </Box>
            <Box display="flex" alignItems="baseline" justifyContent="space-between" marginY={1}>
                <Typography variant="body2">{intl.formatMessage({ id: "data.sodiumTitle" })}</Typography>
                <ParagraphLine />
                <Typography variant="body2">{round(nutritionValues.sodium, 2)} mg</Typography>
            </Box>
            <Box display="flex" alignItems="baseline" justifyContent="space-between" marginY={1}>
                <Typography variant="body2">{intl.formatMessage({ id: "data.caffeineTitle" })}</Typography>
                <ParagraphLine />
                <Typography variant="body2">{round(nutritionValues.caffeine, 2)} mg</Typography>
            </Box>
        </Box>
    );
};

export default NutritionSummary;
